import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface OutageCheckState {
    isOutageCheck: boolean;
    queryParam: string;
}

const initialState: OutageCheckState = {
    isOutageCheck: false,
    queryParam: "outageCheck=Y"
};

export const outageCheckSlice = createSlice({
    name: 'outageCheck',
    initialState,
    reducers: {
        clearOutageCheck: (state)=>{
            return initialState
        },
        setIsOutageCheck: (state, action: PayloadAction<boolean>) => {
            state.isOutageCheck = action.payload;
        },
    },
});

export const { setIsOutageCheck, clearOutageCheck } = outageCheckSlice.actions;
export default outageCheckSlice.reducer;